import { Component, OnInit, Input, Output } from '@angular/core';
import { Form } from '@angular/forms';

import { MainService } from 'app/resources/services/index';
import {
  CartaoDeprecated, TelefoneCelular, TelefoneComercial, TelefoneResidencial,
  EnderecoResidencial,
  DefineBootboxId
} from 'app/resources/classes/index';


@Component({
  moduleId: module.id,
  selector: 'app-form',
  templateUrl: './form.component.html'
})
export class FormComponent implements OnInit {
  @Input() cartao: CartaoDeprecated = new CartaoDeprecated();
  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();
  public sexos: Array<string>;
  public documentoTipo: string;
  public epwdIsNull: any;
  public logradouroIsReadOnly: boolean;
  public bairroIsReadOnly: boolean;
  public processando: boolean;
  public resetEPwdOk: boolean;

  constructor(public mainService: MainService) {
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.logradouroIsReadOnly = true;
    this.bairroIsReadOnly = true;
    this.processando = false;
    this.documentoTipo = this.mainService.cartaoService.documentoTipo;
    this.processando = true;
    this.setCartao();

    this.mainService.http.pathRest().get('enum/sexos/', true)
      .subscribe(sucesso => {
        this.sexos = sucesso.json();
      });
    this.processando = false;

    this.mainService.http.pathRest().get('cartao/current/epwdIsNull/', true)
      .subscribe(
        sucesso => {
          this.epwdIsNull = sucesso.json();
        }
      );
  }

  public save() {
    if (this.isTelefonesPreenchidos()) {
      if (this.validarDados()) {
        this.mainService.http.pathRest().put('cartao/', this.cartao, true)
          .subscribe(sucesso => {
            this.setCartao();
            this.mainService.cartaoService.documentoTipo = this.documentoTipo;
            this.saveSuccess();
          }, erro => {
            this.bootboxAlertComId.alerta(erro._body);
          });
      }
    } else {
      this.bootboxAlertComId.alerta('É necessário preencher ao menos dois números de telefones!')
    }

  }

  public setCartao() {
    this.cartao = this.mainService.cartaoService.recarregar().cartaoCurrent;
    if (!this.mainService.cartaoService.isCompletos()) {
      if (this.cartao.telefoneCelular == undefined) {
        this.cartao.telefoneCelular = new TelefoneCelular({ numero: '', ddd: '' });
      }
      if (this.cartao.telefoneComercial == undefined) {
        this.cartao.telefoneComercial = new TelefoneComercial({ numero: '', ddd: '' });
      }
      if (this.cartao.telefoneResidencial == undefined) {
        this.cartao.telefoneResidencial = new TelefoneResidencial({ numero: '', ddd: '' });
      }
      this.documentoTipo = 'CPF';
      if (this.cartao.enderecoResidencial == undefined) {
        this.cartao.enderecoResidencial = new EnderecoResidencial({
          bairro: '',
          cep: '',
          cidade: '',
          logradouro: '',
          numero: '',
          uf: '',
          complemento: ''
        });
      }
    }

    if (this.cartao.telefoneCelular.ddd === undefined || this.cartao.telefoneCelular.ddd.toString() === '0') {
      this.cartao.telefoneCelular.ddd = '';
    }

    if (this.cartao.telefoneCelular.numero === undefined || this.cartao.telefoneCelular.numero.toString() === '0') {
      this.cartao.telefoneCelular.numero = '';
    }

    if (this.cartao.telefoneComercial.ddd === undefined || this.cartao.telefoneComercial.ddd.toString() === '0') {
      this.cartao.telefoneComercial.ddd = '';
    }

    if (this.cartao.telefoneComercial.numero === undefined || this.cartao.telefoneComercial.numero.toString() === '0') {
      this.cartao.telefoneComercial.numero = '';
    }

    if (this.cartao.telefoneResidencial.ddd === undefined || this.cartao.telefoneResidencial.ddd.toString() === '0') {
      this.cartao.telefoneResidencial.ddd = '';
    }

    if (this.cartao.telefoneResidencial.numero === undefined || this.cartao.telefoneResidencial.numero.toString() === '0') {
      this.cartao.telefoneResidencial.numero = '';
    }
  }

  public saveSuccess() {
    this.mainService.cartaoService.revalidar();

    if (this.epwdIsNull) {
      this.mainService.loginService.changeRoute('/cartao/epwd');

    } else if (!this.epwdIsNull) {
      this.mainService.loginService.changeRoute('/home');
    }

    this.bootboxAlertComId.alerta('Informações salvas com sucesso!');
  }

  public corrigirTelefone(telefone) {
    if (telefone) {
      if (telefone.ddd) {
        if (telefone.ddd.length === 0 || telefone.ddd === '0') {
          return { numero: undefined, ddd: undefined };
        }
      } else {
        return { numero: undefined, ddd: undefined };
      }
    }

    if (telefone) {
      if (telefone.numero) {
        if (telefone.numero.length === 0 || telefone.numero === '0') {
          return { numero: undefined, ddd: undefined };
        }
      } else {
        return { numero: undefined, ddd: undefined };
      }
    }

    if (telefone) {
      if (telefone.ramal) {
        if (telefone.ramal.length === 0 || telefone.ramal === '0') {
          delete telefone.ramal;
        }
      } else {
        delete telefone.ramal;
      }
    }

    return telefone;
  }

  private validarDados(): boolean {
    let verificacao = true;
    this.cartao.telefoneResidencial = this.corrigirTelefone(this.cartao.telefoneResidencial);
    this.cartao.telefoneCelular = this.corrigirTelefone(this.cartao.telefoneCelular);
    this.cartao.telefoneComercial = this.corrigirTelefone(this.cartao.telefoneComercial);

    if (this.documentoTipo === 'CPF' && this.cartao.documento.length !== 11) {
      verificacao = false;
      this.bootboxAlertComId.alerta('O CPF deve conter 11 caracteres');
    } else if (this.documentoTipo === 'CNPJ' && this.cartao.documento.length !== 14) {
      verificacao = false;
      this.bootboxAlertComId.alerta('O CNPJ deve conter 14 caracteres');
    } else {
      verificacao = true;
    }
    if (this.cartao.novaDataNascimento === undefined || this.cartao.novaDataNascimento.length !== 10) {
      this.bootboxAlertComId.alerta('Informe a data de nascimento');
      if (verificacao) {
        verificacao = false;
      }
    }

    return verificacao;

  }

  private isTelefonesPreenchidos(): boolean {
    let quantidadeTelefonesPreenchidos = 0;

    if (this.cartao.telefoneResidencial.ddd !== undefined
      && this.cartao.telefoneResidencial.ddd !== ''
      && this.cartao.telefoneResidencial.numero !== undefined
      && this.cartao.telefoneResidencial.numero !== '') {
      quantidadeTelefonesPreenchidos++;
    }

    if (this.cartao.telefoneCelular.ddd !== undefined
      && this.cartao.telefoneCelular.ddd !== ''
      && this.cartao.telefoneCelular.numero !== undefined
      && this.cartao.telefoneCelular.numero !== '') {
      quantidadeTelefonesPreenchidos++;
    }

    if (this.cartao.telefoneComercial.ddd !== undefined
      && this.cartao.telefoneComercial.ddd !== ''
      && this.cartao.telefoneComercial.numero !== undefined
      && this.cartao.telefoneComercial.numero !== '') {
      quantidadeTelefonesPreenchidos++;
    }
    return quantidadeTelefonesPreenchidos >= 2;
  }
}



// WEBPACK FOOTER //
// ./src/app/menu-superior/meu-cadastro/form/form.component.ts